import { render, staticRenderFns } from "./Activity5_3SingleText.vue?vue&type=template&id=6c124ac8&"
import script from "./Activity5_3SingleText.vue?vue&type=script&lang=js&"
export * from "./Activity5_3SingleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports